import * as React from 'react';
import { SVGProps } from 'react';
export const LogoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    viewBox="0 0 13 13"
    fill="none"
    {...props}
  >
    <path
      fill="#6E7384"
      d="M5.75 12a.75.75 0 0 1-.75.75H1A.75.75 0 0 1 .25 12V1A.75.75 0 0 1 1 .25h4a.75.75 0 0 1 0 1.5H1.75v9.5H5a.75.75 0 0 1 .75.75Zm6.78-6.03-2.5-2.5a.751.751 0 1 0-1.062 1.062l1.22 1.218H5a.75.75 0 0 0 0 1.5h5.188l-1.22 1.22a.751.751 0 0 0 1.062 1.062l2.5-2.5a.75.75 0 0 0 0-1.063Z"
    />
  </svg>
);
